import * as _preactRenderToString2 from "preact-render-to-string";

var _preactRenderToString = "default" in _preactRenderToString2 ? _preactRenderToString2.default : _preactRenderToString2;

var exports = {};

/* eslint-disable */
var renderToString;

try {
  const mod = _preactRenderToString;
  renderToString = mod.default || mod.renderToString || mod;
} catch (e) {
  throw Error("renderToString() error: missing \"preact-render-to-string\" dependency.");
}

exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToString
};
export default exports;
export const renderToStaticMarkup = exports.renderToStaticMarkup;
const _renderToString = exports.renderToString;
export { _renderToString as renderToString };